import React from 'react'
import PropTypes from 'prop-types'
import {
  TYPE_CONTENT_REFERENCES_LIST,
  TYPE_EXPLORE_BY_TOPIC,
  TYPE_CONTENT_LIST,
  TYPE_PLACEMENT,
  TYPE_MY_SERIES,
  TYPE_PROMOTION,
  TYPE_GAIA_ORACLE,
} from '../../services/pm-section/index'

import SectionExploreByTopicV2 from '../SectionExploreByTopic/SectionExploreByTopicV2/index'
import SectionPlacement from '../SectionPlacement/index'
import SectionPromotion from '../SectionPromotion/index'
import SectionTilesList from '../SectionTilesList/index'
import SectionGaiaOracle from '../SectionGaiaOracle/index'

/**
 * The page manager section manager component
 * @type {React.FunctionComponent}
 */
function SectionManager (props) {
  const {
    removeRowHandler,
    addBackHandler,
    rowPlacement,
    screenType,
    location,
    language,
    removed,
    history,
    index,
    type,
    id,
    prevSectionType,
  } = props

  const baseProps = {
    sectionIndex: index,
    sectionId: id,
    location,
  }

  const miscProps = {
    rowPlacement,
  }

  const customizationProps = {
    removeRowHandler,
    addBackHandler,
    removed,
  }

  switch (type) {
    case TYPE_PLACEMENT:
      return (
        <SectionPlacement
          {...baseProps}
          language={language}
          history={history}
        />
      )
    case TYPE_PROMOTION: {
      return (
        <SectionPromotion
          sectionIndex={index}
          sectionId={id}
          rowPlacement={rowPlacement}
        />
      )
    }
    case TYPE_GAIA_ORACLE: {
      return (
        <SectionGaiaOracle
          sectionIndex={index}
          sectionId={id}
          history={history}
          prevSectionType={prevSectionType}
          rowPlacement={rowPlacement}
        />
      )
    }
    case TYPE_EXPLORE_BY_TOPIC: {
      return (
        <SectionExploreByTopicV2
          {...baseProps}
          {...miscProps}
        />
      )
    }
    case TYPE_CONTENT_LIST:
    case TYPE_CONTENT_REFERENCES_LIST:
    case TYPE_MY_SERIES: {
      return (
        <SectionTilesList
          {...baseProps}
          {...miscProps}
          {...customizationProps}
          screenType={screenType}
          sectionType={type}
          prevSectionType={prevSectionType}
        />
      )
    }
    default:
      return (
        <SectionTilesList
          {...baseProps}
          {...miscProps}
          screenType={screenType}
          sectionType={type}
          prevSectionType={prevSectionType}
        />
      )
  }
}

SectionManager.propTypes = {
  type: PropTypes.string.isRequired,
  removeRowHandler: PropTypes.func,
  id: PropTypes.string.isRequired,
  rowPlacement: PropTypes.number,
  addBackHandler: PropTypes.func,
  location: PropTypes.object,
  language: PropTypes.string,
  history: PropTypes.object,
  index: PropTypes.number,
  removed: PropTypes.bool,
  onRef: PropTypes.func,
  screenType: PropTypes.string.isRequired,
  prevSectionType: PropTypes.string,
}

export default React.memo(SectionManager)
